class Config {
	version = 'zonnedakje@' + (import.meta.env.VITE_VERSION_TAG || 'dev');
	env = import.meta.env.VITE_ENVIRONMENT || 'dev';
}

export const CONFIG = new Config();
